import ApiMethods from 'shared/api/api-methods';
import type { ISSEToken } from 'shared/types/sse';

export async function fetchSSEToken(): Promise<ISSEToken | null> {
  const data = await ApiMethods.post('/events', {}, 'notifications');
  if (!data.ok) {
    if (data.type === 'opaque') return null;
    throw Error(`${data.status}`);
  }
  return await data.json();
}
